import _extends from "@babel/runtime/helpers/extends";

/**
 * @type utils
 * @name componentUtils
 */
export * from './hooks';
export * from './type';
export function getStyleWithVendor(style) {
  var allowReg = /(transform|transition|animation)/i;
  var newStyle = Object.keys(style).reduce(function (acc, key) {
    var _ref, _extends2;

    var webkitStyle = allowReg.test(key) ? (_ref = {}, _ref["Webkit" + key.replace(/^(.)/, function (_, p1) {
      return p1.toUpperCase();
    })] = style[key], _ref) : {};
    return _extends({}, acc, (_extends2 = {}, _extends2[key] = style[key], _extends2), webkitStyle);
  }, {});
  return newStyle;
}
/**
 * 计算默认值，仅未定义时使用默认值
 * @desc {en} Calculate the default value, use default value only if undefined
 */

export var getDefaultValue = function getDefaultValue(value, defaultValue) {
  return value === void 0 ? defaultValue : value;
};